import { Box } from '@chakra-ui/react';
import { useLocation, Navigate } from 'react-router-dom';

import { Condition } from 'Component/others';
import { useUserInfo } from 'Store/userInfo';
import checkPublicRoute from 'Helper/checkPublicRoute';
import useGetHelpRequestStatus from 'Domain/host-help-partner/useGetHelpRequestStatus';

import Form from 'View/host-help-partner/section/form';
import Requesting from 'View/host-help-partner/section/requesting';
import Done from 'View/host-help-partner/section/done';

import styles from './styles.module.css';

const HostHelpPartner = () => {
  const { organization } = useUserInfo();
  const isMalayOrg = organization?.region === 'MY';

  const { pathname } = useLocation();
  const isPublic = checkPublicRoute(pathname);
  const { data: helpRequest } = useGetHelpRequestStatus({ isPublic });

  if (isMalayOrg) return <Navigate to="/host" replace />;

  return (
    <Box className={styles['host-help__container']}>
      <Condition statement={helpRequest?.status === 'IDLE'} children={<Form />} />
      <Condition statement={helpRequest?.mappedStatus === 'SEARCHING'} children={<Requesting helpRequest={helpRequest} />} />
      <Condition statement={helpRequest?.mappedStatus === 'ASSIGNED'} children={<Done dataStatusHelp={helpRequest} />} />
    </Box>
  );
};

export default HostHelpPartner;
